import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  Signal,
  contentChild,
} from '@angular/core';
import { GusDialogConfig, GusDialogCloseEvent } from '../../models/dialog.models';
import { DialogFooterComponent } from '../dialog-footer/dialog-footer.component';
import { DialogBodyComponent } from '../dialog-body/dialog-body.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';

@Component({
  selector: 'gus-generic-dialog',
  host: { class: 'gus-generic-dialog' },
  templateUrl: './generic-dialog.component.html',
  styleUrl: './generic-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericDialogComponent {
  @Input() isLoading: boolean = false;

  @Output() primaryButtonClicked: EventEmitter<boolean> = new EventEmitter();

  @Output() secondaryButtonClicked: EventEmitter<boolean> = new EventEmitter();

  protected customHeader: Signal<DialogHeaderComponent | undefined> = contentChild(DialogHeaderComponent);

  protected customBody: Signal<DialogBodyComponent | undefined> = contentChild(DialogBodyComponent);

  protected customFooter: Signal<DialogFooterComponent | undefined> = contentChild(DialogFooterComponent);

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: GusDialogConfig,
    private readonly dialogRef: MatDialogRef<GenericDialogComponent, GusDialogCloseEvent>
  ) {}

  close(): void {
    this.dialogRef.close({ closeButtonClicked: true });
  }

  handlePrimaryButtonClick(): void {
    this.primaryButtonClicked.emit();

    if (this.data.closeOnButtonClick) {
      this.dialogRef.close({ primaryButtonClicked: true });
    }
  }

  handleSecondaryButtonClick(): void {
    this.secondaryButtonClicked.emit();

    if (this.data.closeOnButtonClick) {
      this.dialogRef.close({ secondaryButtonClicked: true });
    }
  }
}
